import api from "../../../api";

export const requestGetOfferImages = (id) => api.get(`/partofferimage/images/${id}`);

export const requestAddOfferImages = (payload) => {
    return api.post(`/partofferimage/images`, payload);
};
export const requestDeleteOfferImage = (image_id) => api.delete(`/partofferimage/images/${image_id}`);
